import PropTypes from "prop-types";
import { get, isEmpty } from "lodash";
import cn from "../../../utils/cn";
import "./LogoLoader.css";
import { ICONS } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LogoLoader = props => {
  const {
    id = "",
    description = "",
    height = null,
    width = null,
    styleClass = "",
    color = "brand-blue"
  } = props;
  const icon = ICONS.IconLogoLoader;
  const iconImage = get(icon, "markup", null);
  const viewBox = get(icon, "viewBox", null);
  const logoClass = cn("logo-loader text-".concat(color), styleClass);
  return /*#__PURE__*/_jsxs("div", {
    className: logoClass,
    id: id,
    children: [/*#__PURE__*/_jsx("svg", {
      height: height,
      width: width,
      viewBox: viewBox,
      className: "mx-auto",
      children: iconImage
    }), !isEmpty(description) && /*#__PURE__*/_jsx("p", {
      className: "logo-loader__text text-center",
      children: description
    })]
  });
};
LogoLoader.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** text to appear below UULogoLoader image */
  description: PropTypes.string,
  /** height of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
   */
  height: PropTypes.number,
  /** width of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
   */
  width: PropTypes.number,
  /** Use custom tailwind classes - Replaces style object */
  styleClass: PropTypes.string
};
export default LogoLoader;
//# sourceMappingURL=LogoLoader.js.map